import { Close } from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { Position } from '@staffedupusa/shared-components';
import { CongratsIcon } from '../../../vectors/index';
import React, { useEffect } from 'react';
import { useUpdateJobPosting } from '@features/jobPostings/hooks/useUpdateJobPosting';
import { useNavigate } from 'react-router-dom';

function SatffedFullModal({ fullJobs }: { fullJobs: Position[] }) {
  const jobsLength = fullJobs?.length || 0;
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const { updateJobPosting } = useUpdateJobPosting({ refetch: true });

  const hanldeClose = (type?: number) => {
    fullJobs?.forEach((position: Position) => {
      updateJobPosting({
        id: position.id,
        reviewed_job_updates: 0,
      });
    });
    if (type === 1) navigate('/employer/positions/');
    setOpen(false);
  };
  useEffect(() => {
    setOpen(true);
  }, []);
  return (
    <Dialog open={open} onClose={() => hanldeClose(0)} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={() => hanldeClose(0)}
        >
          <Close />
        </IconButton>
        <br />
        <CongratsIcon />
        {jobsLength > 1 ? (
          <>
            <Typography variant="h4" mt={1}>
              Your <b> {fullJobs.map((job) => job.s_title).join(', ')}</b>{' '}
              positions are fully staffed!
            </Typography>
            <Typography color="gray" variant="body1" mt={1} fontSize={14}>
              The hiring status for positions is now set to accepting.
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="h4" mt={1}>
              Your <b>{fullJobs[0].s_title}</b> position is fully staffed!
            </Typography>
            <Typography color="gray" variant="body1" mt={1} fontSize={14}>
              The hiring status for this role is now set to accepting.
            </Typography>
          </>
        )}
      </DialogTitle>
      <DialogContent>
        <Typography textAlign="center" variant="body1" mt={1}>
          We’ve set the hiring status based on your automation settings. If
          you’d like to adjust your position status
          <br /> or par levels for this position, you can update it <br />
          in your Job Management settings.
        </Typography>
        <Stack spacing={3} mt={4} mb={2}>
          <Button onClick={() => hanldeClose(0)} variant="contained">
            All Set
          </Button>
          <Button onClick={() => hanldeClose(1)} variant="outlined">
            Update My Settings
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default SatffedFullModal;
